<template>
  <div>
    <option-config :data="model.data" @update:data="updateData" />
  </div>
</template>

<script>
import OptionConfig from './OptionConfig.vue';

export default {
  components: {
    OptionConfig,
  },
  props: {
    data: Object,
    config: Object,
  },
  data() {
    return {
      model: {
        data: [],
      },
    };
  },
  created() {
    this.model = this.data || { data: [] };
  },
  methods: {
    updateData(newData) {
      this.model.data = newData;
      this.$emit('update:data', this.model);
    },
  },
};
</script>

<style scoped>
</style>
